import { API_URL } from "../config/entrypoints";
import { usersService } from "../services";
import axios from "axios";

export const fetchWrapper = {
  get,
  get_pdf,
  post_token,
  post,
  post_formdata,
  put,
  put_formdata,
  put_hors_data,
  delete: _delete,
  post_refresh,
};

function get(url) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  return fetch(`${API_URL}/${url}`, requestOptions).then(handleResponse);
}

function get_pdf(url) {
  const requestOptions = {
    method: "GET",
    url: `${API_URL}/${url}`,
    headers: {
      responseType: "blob",
    },
  };
  return axios(requestOptions).then((response) => {
    response.data.blob();
  });
}

function post_formdata(url, formdata) {
  const requestOptions = {
    method: "POST",
    url: `${API_URL}/${url}`,
    headers: {
      "Content-Type": "multipart/form-data",
      ...authHeader(),
    },
    data: formdata,
  };
  return axios(requestOptions);
}

function post_token(url, body) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(body),
  };
  return fetch(`${API_URL}/${url}`, requestOptions);
}

function post(url, body) {
  const requestOptions = {
    method: "POST",
    url: `${API_URL}/${url}`,
    headers: { "Content-Type": "application/json", ...authHeader() },
    data: JSON.stringify(body),
  };
  return axios(requestOptions);
}

function put(url, body) {
  const requestOptions = {
    method: "PUT",
    url: `${API_URL}/${url}`,
    headers: { "Content-Type": "application/json", ...authHeader() },
    data: JSON.stringify(body),
  };
  return axios(requestOptions);
}


function put_hors_data(url, params) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  return fetch(`${API_URL}/${url}`, requestOptions).then(handleResponse);
}

function put_formdata(url, formdata) {
  const requestOptions = {
    method: "PUT",
    url: `${API_URL}/${url}`,
    headers: { "Content-Type": "multipart/form-data", ...authHeader() },
    data: formdata,
  };
  return axios(requestOptions);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(url) {
  const requestOptions = {
    method: "DELETE",
    url: `${API_URL}/${url}`,
    headers: authHeader(),
  };
  return axios(requestOptions);
}

// helper functions

function authHeader() {
  // return auth header with jwt if user is logged in and request is to the api url
  const token = usersService.tokenValue;
  const isLoggedIn = token && token;
  if (isLoggedIn) {
    return { Authorization: `Bearer ${token}` };
  } else {
    return {};
  }
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if ([401].includes(response.status)) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        usersService.logout();
      }

      if (response.status === 422) {
        return Promise.reject(data.violations);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

function post_refresh(url, refreshToken) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${refreshToken}`,
    },
  };

  return fetch(`${API_URL}/${url}`, requestOptions).then(handleResponse);
}